/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakInvitationResponse } from './StreakInvitationResponse';
import {
    StreakInvitationResponseFromJSON,
    StreakInvitationResponseFromJSONTyped,
    StreakInvitationResponseToJSON,
    StreakInvitationResponseToJSONTyped,
} from './StreakInvitationResponse';

/**
 * 
 * @export
 * @interface SharedStreakInviteResponse
 */
export interface SharedStreakInviteResponse {
    /**
     * 
     * @type {StreakInvitationResponse}
     * @memberof SharedStreakInviteResponse
     */
    invitation: StreakInvitationResponse;
}

/**
 * Check if a given object implements the SharedStreakInviteResponse interface.
 */
export function instanceOfSharedStreakInviteResponse(value: object): value is SharedStreakInviteResponse {
    if (!('invitation' in value) || value['invitation'] === undefined) return false;
    return true;
}

export function SharedStreakInviteResponseFromJSON(json: any): SharedStreakInviteResponse {
    return SharedStreakInviteResponseFromJSONTyped(json, false);
}

export function SharedStreakInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedStreakInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitation': StreakInvitationResponseFromJSON(json['invitation']),
    };
}

export function SharedStreakInviteResponseToJSON(json: any): SharedStreakInviteResponse {
    return SharedStreakInviteResponseToJSONTyped(json, false);
}

export function SharedStreakInviteResponseToJSONTyped(value?: SharedStreakInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitation': StreakInvitationResponseToJSON(value['invitation']),
    };
}

